import { FC } from 'react';

import { useApp } from '@hooks/AppHooks';

const AssumedRoleBanner: FC = () => {
    const { isAssumedRole, user } = useApp();

    if (!isAssumedRole || !user) {
        return null;
    }

    return (
        <div
            style={{
                backgroundColor: '#ff9800',
                color: 'white',
                padding: '8px 16px',
                textAlign: 'center',
                fontWeight: 'bold',
                borderBottom: '1px solid #f57c00',
                zIndex: 300,
            }}
        >
            🎭 Assumed Role Mode - Viewing as: {user.fullName} ({user.email || user.phoneNumber})
            <button
                type="button"
                style={{
                    marginLeft: '16px',
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                }}
                onClick={() => window.close()}
            >
                Close Window
            </button>
        </div>
    );
};

export default AssumedRoleBanner;
